/**
 * Normalize a user-typed custom block name into a clean stored category string,
 * mirroring the NORMALIZATION CORE of backend slugify_category() (prompt_renderer.py,
 * steps 1-3). The backend ALSO reserves the curated tag/header namespace at RENDER
 * time (a category colliding with a curated tag is prefixed `custom_` there), so the
 * frontend deliberately does NOT replicate that reservation — this yields the stored
 * `category`; the backend guarantees the rendered prompt-section is collision-safe.
 */
export function slugifyCategory(raw: string): string {
  const step1 = (raw || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
  if (!/[a-z]/.test(step1)) return 'custom'
  const core = step1
    .replace(/^[^a-z]+/, '')
    .replace(/^_+|_+$/g, '')
    .slice(0, 40)
    .replace(/^_+|_+$/g, '')
  return core || 'custom'
}
